const POLICY_TYPES = Object.freeze({
  CAMPAIGN: "CAMPAIGN",
  CLEANLINESSLAB: "CLEANLINESSLAB",
});

const SEMI_MALICE_REPORT_REASON_KEYS = Object.freeze(["ASK_CONTACT"]);
const MALICE_REPORT_REASON_KEYS = Object.freeze([
  "SEXUAL_TALK",
  "SCAM_TALK",
  "VIOLENT_TALK",
]);

function evaluatePolicy({ zeroMaliceGroup, domain, selectedReasonKey }) {
  const normalizedGroup = (zeroMaliceGroup || "").toString().toUpperCase();
  const normalizedDomain = (domain || "").toString().toUpperCase();
  const reasonKey = (selectedReasonKey || "").toString().toUpperCase();

  const matchesCampaignGroup = normalizedGroup === "B" || normalizedGroup === "C";
  const matchesDomain = normalizedDomain === "CALL";
  const matchesReason =
    SEMI_MALICE_REPORT_REASON_KEYS.includes(reasonKey) ||
    MALICE_REPORT_REASON_KEYS.includes(reasonKey);

  const type =
    matchesCampaignGroup && matchesDomain && matchesReason
      ? POLICY_TYPES.CAMPAIGN
      : POLICY_TYPES.CLEANLINESSLAB;

  return {
    type,
    reasonKey: reasonKey || null,
  };
}

module.exports = {
  POLICY_TYPES,
  SEMI_MALICE_REPORT_REASON_KEYS,
  MALICE_REPORT_REASON_KEYS,
  evaluatePolicy,
};
